const CHUNK_RELOAD_KEY = 'app_chunk_reload_at';
const CHUNK_RELOAD_COOLDOWN_MS = 15_000;

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Failed to load module script/i,
  /error loading dynamically imported module/i,
  /Expected a JavaScript-or-Wasm module script/i,
  /MIME type of "text\/html"/i,
  /Loading chunk \d+ failed/i,
  /ChunkLoadError/i,
];

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const message = typeof error === 'string' ? error : error?.message || String(error);
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export const recoverFromChunkError = (error) => {
  if (!isChunkLoadError(error)) return false;

  const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  const now = Date.now();

  if (now - lastReload < CHUNK_RELOAD_COOLDOWN_MS) {
    return false;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));

  const url = new URL(window.location.href);
  url.searchParams.set('_refresh', String(now));
  window.location.replace(url.toString());
  return true;
};

export const clearChunkReloadGuard = () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
};

export const installChunkRecovery = () => {
  if (window.__chunkRecoveryInstalled) return;
  window.__chunkRecoveryInstalled = true;

  window.addEventListener('unhandledrejection', (event) => {
    if (recoverFromChunkError(event.reason)) {
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    const candidate = event.error || event.message;
    if (recoverFromChunkError(candidate)) {
      event.preventDefault();
    }
  });
};
